import React, { FC, useState } from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"
import { toast } from "react-toastify"
import { KyzzenUser } from "../../../types"
import { ENDPOINT } from "../../../constants"
import { useAuth } from "../../../contexts/AuthContext"

type Props = {
  isModalOpen: boolean
  user: KyzzenUser | null
  closeModal: () => void
  refetch: () => void
}
const DeleteUserModal: FC<Props> = ({
  isModalOpen,
  closeModal,
  user,
  refetch,
}) => {
  const { getUserJWT } = useAuth()
  const [deleting, setDeleting] = useState(false)

  const deleteUser = async () => {
    try {
      setDeleting(true)
      const userJWT = getUserJWT()
      const res = await fetch(`${ENDPOINT.DELETE_KYZZEN_USER}/${user?.id}`, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json",
          Authorization: userJWT ? `Bearer ${userJWT}` : "",
        },
      })
      const data = await res.json()

      if (!res.ok) throw new Error(data.message)

      closeModal()
      refetch()
    } catch (err) {
      console.error((err as Error)?.message)
      toast.error((err as Error)?.message)
    } finally {
      setDeleting(false)
    }
  }

  return (
    <Dialog
      open={isModalOpen}
      onClose={closeModal}
      PaperProps={{
        className:
          "bg-kyzzen-primary border border-kyzzen-secondary text-white",
      }}
    >
      <DialogTitle>Delete {user?.username}&apos;s account</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="text-gray-40"
        >
          You are about to delete {user?.username}'s account.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color="inherit">
          Cancel
        </Button>
        <Button color="error" autoFocus onClick={deleteUser}>
          {deleting ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteUserModal
